import { createLucideIcon } from "lucide-react";

export const Security = createLucideIcon(
    "Security",
    [
        [
            "path",
            {
                d: "M11.9982 2.00012C8.99043 2.00012 7.04018 4.01911 4.73371 4.75502C3.79589 5.05425 3.32697 5.20387 3.1372 5.41477C2.94743 5.62568 2.89186 5.93387 2.78072 6.55026C1.59143 13.1461 4.1909 19.2441 10.3903 21.6176C11.0564 21.8726 11.3894 22.0001 12.0015 22.0001C12.6135 22.0001 12.9466 21.8726 13.6126 21.6176C19.8116 19.2441 22.4086 13.1461 21.219 6.55025C21.1078 5.93376 21.0522 5.62552 20.8624 5.41461C20.6726 5.2037 20.2037 5.05417 19.2659 4.75511C16.9585 4.01927 15.0061 2.00012 11.9982 2.00012Z",
                key: "c88mea",
            },
        ],
        [
            "path",
            {
                d: "M12 7.00012L12 9.00012",
                key: "ik7985",
            },
        ],
    ],
);
